import { render, staticRenderFns } from "./ManageDriverListView.vue?vue&type=template&id=bb1ad4e0"
import script from "./ManageDriverListView.vue?vue&type=script&lang=ts"
export * from "./ManageDriverListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports